import { useEffect, useRef } from "react";

/**
 * A1-93 round 4 — push a panel-local input UP to the workflow only when it
 * CHANGES, never on mount.
 *
 * CalculatePanel keeps local copies of the selection / period / country
 * filter and used to push them up on mount too. Found in Chromium with a
 * slow sign-in check: the route change that mounts Step 1 is rendered as a
 * React transition, and could commit with the workflow state from BEFORE a
 * calc link finished opening — the panel mounted with an empty selection
 * and the default period, and its mount-time push wiped the calc's files
 * and period a moment after they were set ("files changed", "period
 * changed", steps 1-3 un-ticked, Run calculation chip locked). A freshly
 * mounted panel has nothing to tell the workflow; only an operator's
 * change does.
 */
export const useMirrorUp = (value, push) => {
  const lastRef = useRef(value);
  useEffect(() => {
    if (Object.is(value, lastRef.current)) return;
    lastRef.current = value;
    push?.(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
};
